import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import { getCapchaCode, ReservationManager } from '../action/loginAction.js';
import { Toast,Modal,Carousel, WingBlank } from 'antd-mobile/lib';
import Util from '../util';
import { AnswerAlert } from './AnswerAlert'


function closest(el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

  

class Answer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertFlag:false
    };

  }
  componentDidMount(){
  }
  componentWillMount(){
     window._czc.push(["_trackEvent", "华夏财富H5", "答题", "进入答题"]);
  }
  componentWillUnmount(){
    window._czc.push(["_trackEvent", "华夏财富H5", "答题", "离开答题"]);
  }
  succallback(){
    // alert()
  }
  errcallback(msg){
    // alert(msg)
  }
  beginAnswer(){
    hashHistory.push({
        pathname:'/Login', 
        // pathname:'/AnswePage', 
        
        state:{},
        query: {enterType:"Answer"},
    })
  }
  pushDetail(){
  //  window.location.href = "https://www.amcfortune.com/minipage/zdz/app/index.html";
  //  window.location.href = "https://www.amcfortune.com/minipage/hxcy/app/index.html";
   window.location.href = " https://www.amcfortune.com/minipage/xywap/index.html";
  
  
  }
  alertRule(){
    this.setState({
      alertFlag:true
    })
  }
  handleClose(){
    this.setState({
      alertFlag:false
    })
  }
  render(){
    let { width, height } = window.screen;
    let { alertFlag } = this.state;
    return(
      <div className="AnswerContent" style={{height:height}}>
    
              <div
                style={{  width: '100%',position:"relative" }}
              >
                <img
                  src={require('../img/answerPIC15.png')}
                  alt=""
                  style={{ width: width, verticalAlign: 'top' }}
        
                />
                <div onClick={()=> {this.alertRule() }} style={{width:150,height:50,position:"absolute",top:10,right:0,zIndex:9,background:"rgba(0,0,0,0)"}} ></div>
                
                
                {/* <div className="jionAnswer" style={{width:width,bottom:width/(750/100),height:width/(750/123),zIndex:9,}}>
                  <div onClick={()=> {this.beginAnswer() }} style={{height:width/(750/123)}}></div>
                </div> */}
               

                <div className="jionAnswer" style={{width:width,bottom:width/(750/180),height:width/(750/75),zIndex:9, }}>
                  <div onClick={()=> {this.beginAnswer() }} style={{height:width/(750/75),}}></div>
                </div>
                <div className="jionMore" style={{width:width,bottom:width/(750/76),height:width/(750/75),zIndex:9, }}>
                  <div onClick={()=> {this.pushDetail() }} style={{height:width/(750/75),}}></div>
                </div>
              </div>

    
       
        {
          alertFlag ? <AnswerAlert Close={ this.handleClose.bind(this) } /> : null
        }
        
      </div>
    )
    // return (
    //     <div>
    //         <div className="Answer" style={{width:width,height:width*(2871/750)}}>
    //           <div style={{width:150,height:50,position:"absolute",top:10,right:0,background:"rgba(0,0,0,0)"}}></div>
    //         </div>
    //     </div>
    // );
  }
}


function mapStateToProps(state, ownProps) {
  return {

  }
}

export default connect(mapStateToProps)(Answer);



// WEBPACK FOOTER //
// ./src/components/Answer.js